import { render, staticRenderFns } from "./IpFirewallTableItem.vue?vue&type=template&id=6bf8cd2a&scoped=true"
import script from "./IpFirewallTableItem.vue?vue&type=script&lang=js"
export * from "./IpFirewallTableItem.vue?vue&type=script&lang=js"
import style0 from "./IpFirewallTableItem.vue?vue&type=style&index=0&id=6bf8cd2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8cd2a",
  null
  
)

export default component.exports